<template>
    <div id="app-page">
        <a-config-provider :locale="locale === 'zh-CN' ? zhCN : enUS">
            <router-view></router-view>
        </a-config-provider>
    </div>
</template>

<script setup lang="ts">
import zhCN from "ant-design-vue/es/locale/zh_CN";
import enUS from "ant-design-vue/es/calendar/locale/en_US";
import { useI18n } from "vue-i18n";

const { locale } = useI18n();
</script>

<style lang="scss" scoped>
#app-page {
    position: relative;
    height: 100%
}
</style>
